module.exports = ".education-content {\n    padding-top: 15px;\n}"